import { render } from "./ChooseRoom.vue?vue&type=template&id=fb753bac&scoped=true"
import script from "./ChooseRoom.vue?vue&type=script&lang=js"
export * from "./ChooseRoom.vue?vue&type=script&lang=js"

import "./ChooseRoom.vue?vue&type=style&index=0&id=fb753bac&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-fb753bac"

export default script